import { FluentIcon } from '@fluentui/react-icons';
import { FC, MouseEventHandler } from 'react';

type TButton = FC<{
  label?: string;
  disabled?: boolean;
  color?: string;
  backgroundColor?: string;
  icon: FluentIcon;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}>;

const Button: TButton = ({ label = '', disabled = false, color, backgroundColor, icon: Icon, onClick }) => (
  <button
    role="button"
    disabled={disabled}
    style={{
      cursor: disabled ? 'not-allowed' : 'pointer',
      color: disabled ? 'white' : color || '#242424',
      background: disabled ? '#aaa' : backgroundColor || '#fff',
      padding: '0.5rem 1rem',
      fontSize: '14px',
      fontWeight: '600',
      borderRadius: '4px',
      border: '1px solid #D1D1D1',
      marginTop: 'auto',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.25rem',
      height: '32px',
      /*
      '&:hover': {
        backgroundColor: disabled ? '#0F6CBD' : '#f0f0f0',
        //color: disabled ? 'white' : color || '#242424',
      },
      */
    }}
    onClick={onClick}
  >
    {Icon && <Icon style={{ marginTop: 'auto', marginBottom: 'auto' }} />}
    {label}
  </button>
);

export default Button;
